import React from 'react';
import { Button, Col, Input, Row } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getLocalItem } from "../../../infrastructure/storage/LocalStorage";

const NewPublicationBarProfile = ({ open, setOpen, ModalComponent }) => {

    const [inputText, setInputText] = useState("");
    const [uiTexts, setUiTexts] = useState({});

    useEffect(() => {
        const texts = getLocalItem("texts");
        setUiTexts(texts);
    }, []);
    
    return (
        <>
            {/* 🔹 Ahora el modal es dinámico y se pasa como prop */}
            {ModalComponent && <ModalComponent open={open} setOpen={setOpen} />}

            <Row 
                justify={"center"}
                style={{
                    width: "100%",
                    backgroundColor: "var(--gray-bg-color)",
                    borderRadius: "17px",
                    lineHeight: "48px",
                }}
            >
                <Col span={24}>
                    <Row justify={"center"} align={"middle"}>
                        <Col xs={4} sm={4} md={3} lg={2} xl={2}>
                            <Row justify={"center"} align={"middle"}>
                                <Button
                                    type={"text"}
                                    style={{ backgroundColor: "#fff", width: "80%" }}
                                    onClick={() => {
                         
                                    if (setOpen) {
                                        setOpen(true);
                                    } else {
                                        console.error(
                                        "setOpen no está definido en NewPublicationBar"
                                        );
                                    }
                                    }}
                                >
                                    <img src={"/img/icons/place-icon.svg"} alt={"place"} />
                                </Button>
                            </Row>
                        </Col>
                        <Col xs={4} sm={4} md={3} lg={2} xl={2}>
                            <Row justify={"center"} align={"middle"}>
                                <Button
                                    type={"text"}
                                    style={{ backgroundColor: "#fff", width: "80%" }}
                                    onClick={() => {
                                   
                                    if (setOpen) {
                                        setOpen(true);
                                    } else {
                                        console.error(
                                        "setOpen no está definido en NewPublicationBar"
                                        );
                                    }
                                    }}
                                >
                                    <img src={"/img/icons/location-icon.svg"} alt={"place"} />
                                </Button>
                            </Row>
                        </Col>
                        <Col span={1}></Col>
                        <Col xs={13} sm={13} md={14} lg={16} xl={18}>
                            <Input
                                suffix={<EditOutlined className="new-publication-profile-edit-icon" />}
                                placeholder={uiTexts?.LB0062}
                                style={{ width: "100%" }}
                                onClick={() => {
                                 
                                    if (setOpen) {
                                    setOpen(true);
                                    } else {
                                    console.error(
                                        "setOpen no está definido en NewPublicationBar"
                                    );
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default NewPublicationBarProfile;
